import { useRoleOptions, useCategoryOptions } from './useMasterOptions';
// Add other options hooks as needed

export const useUserFormOptions = () => {
  const { options: roleOptions } = useRoleOptions();
  // Add other options here
  // const { options: departmentOptions } = useDepartmentOptions();

  return {
    role: roleOptions,
    // department: departmentOptions,
    // Add more options as needed
  };
};

export const useExpenseFormOptions = () => {
  const { options: categoryOptions } = useCategoryOptions();

  return {
    category: categoryOptions,
  };
};